var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.836426,
    y: 0.578125,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#E0F2CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2775 40.5493L45.7475 29.0781L47.5131 30.8425L34.2775 44.0781L26.3364 36.137L28.1008 34.3726L34.2775 40.5493Z",
    fill: "#65BE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCheck);
export default __webpack_public_path__ + "static/media/round-check.c8531f8d1b5c76d486dbfc995f0a8b4b.svg";
export { ForwardRef as ReactComponent };